import React, { useEffect, useState } from 'react';
import Workout from './Workout';
import './TravelReplacementOriginalModal.css';

const TravelReplacementOriginalModal = ({ replacementActivity, backendService, exercises = [], modalService }) => {
  const [original, setOriginal] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const originalActivityId = replacementActivity?.source?.replaces_activity_id;
  const replacementName = replacementActivity?.name || 'the Travel Replacement Activity';
  const replacementIsComplete = ['complete', 'completed'].includes(replacementActivity?.status);
  const originalTimingCopy = replacementIsComplete ? 'did not happen' : 'will not happen';

  useEffect(() => {
    document.body.classList.add('travel-original-modal-open');
    return () => document.body.classList.remove('travel-original-modal-open');
  }, []);

  useEffect(() => {
    let active = true;
    const load = async () => {
      if (!originalActivityId) {
        if (active) {
          setError('The original workout link is unavailable.');
          setLoading(false);
        }
        return;
      }
      try {
        setLoading(true);
        setError(null);
        const activity = await backendService.fetchActivity(originalActivityId);
        if (active) setOriginal(activity);
      } catch (fetchError) {
        if (active) {
          setError(fetchError?.response?.data?.error || fetchError?.message || 'Could not load the original workout.');
        }
      } finally {
        if (active) setLoading(false);
      }
    };
    load();
    return () => { active = false; };
  }, [backendService, originalActivityId]);

  return (
    <div className="travel-original-modal">
      <header className="travel-original-modal-header">
        <span className="travel-original-modal-kicker">Original scheduled workout</span>
        <h2>{original?.name || replacementActivity?.data?.travel_replacement?.original_workout_name || 'Replaced workout'}</h2>
      </header>

      <div className="travel-original-status" role="status">
        <span className="travel-original-status-mark" aria-hidden="true">×</span>
        <div>
          <strong>Replaced — not performed</strong>
          <p>
            This workout {originalTimingCopy} and cannot be started. {replacementName} now carries its consistency obligation.
          </p>
        </div>
      </div>

      {loading && <div className="travel-original-loading">Loading original workout…</div>}
      {!loading && error && <div className="travel-original-error" role="alert">{error}</div>}
      {!loading && original && (
        <div className="travel-original-workout" aria-label="Read-only original workout">
          <Workout
            workout={original}
            exercises={exercises}
            modalService={modalService}
            backendService={backendService}
            readOnly
          />
        </div>
      )}
    </div>
  );
};

export default TravelReplacementOriginalModal;
